import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74c92e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mainDiv",
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "display-flex" }
const _hoisted_3 = {
  class: "display-flex",
  style: {"width":"60% !important","margin-left":"1%","float":"left"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"2rem !important","font-weight":"700 !important","font-style":"italic","width":"18%"} }, "SCAN-PC", -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  style: {"color":"red","font-weight":"bold","margin-left":"2%","width":"82%","text-align":"left"}
}
const _hoisted_6 = { style: {"width":"40% !important","margin-right":"2%","float":"right"} }
const _hoisted_7 = { class: "display-flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"2rem !important","width":"40%"} }, "Station Code:", -1 /* HOISTED */))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"border":"solid 1px"} }, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "display-flex margin-top" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "File Status：", -1 /* HOISTED */))
const _hoisted_13 = { class: "form-check align-left adjusting-position" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-5",
  for: "notDownloaded"
}, " Not Downloaded ", -1 /* HOISTED */))
const _hoisted_15 = { class: "form-check align-left adjusting-position margin-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-5",
  for: "downloaded"
}, " Downloaded ", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5 margin-left-40" }, "Select Date：", -1 /* HOISTED */))
const _hoisted_18 = { class: "form-check align-left adjusting-position" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-check align-left adjusting-position" }
const _hoisted_21 = { class: "display-flex margin-top" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "Data ID：", -1 /* HOISTED */))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "ALL DATA ID", -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5 margin-left" }, "From Station：", -1 /* HOISTED */))
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "ALL STATION", -1 /* HOISTED */))
const _hoisted_28 = { class: "adjusting-position fs-5 margin-left" }
const _hoisted_29 = { class: "align-right-position" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-in-down" }, null, -1 /* HOISTED */))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Download all ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-return-right" }, null, -1 /* HOISTED */))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Upload Page ")
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary margin-left btn-width"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-return-right" }),
  /*#__PURE__*/_createTextVNode(" Upload Page ")
], -1 /* HOISTED */))
const _hoisted_39 = {
  class: "margin-top",
  style: {"width":"80vw","margin-left":"10%","margin-right":"auto"}
}
const _hoisted_40 = {
  id: "tblDownloadFiles",
  style: {"width":"calc(80vw - 16px)"}
}
const _hoisted_41 = { class: "table-warning" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"9%"}
}, "ControlNo.", -1 /* HOISTED */))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"9%"}
}, "Data ID", -1 /* HOISTED */))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"10%"}
}, "Ref-No.", -1 /* HOISTED */))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"7%"}
}, "From", -1 /* HOISTED */))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"35%"}
}, "Date(JST・MM/DD/YYYY)", -1 /* HOISTED */))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"15%"}
}, "Preview", -1 /* HOISTED */))
const _hoisted_48 = {
  key: 0,
  scope: "col",
  style: {"width":"15%"}
}
const _hoisted_49 = {
  id: "divBodayDownload",
  style: {"height":"calc(80% - 220px)","overflow":"auto","margin":"0 auto 0 10%"}
}
const _hoisted_50 = { id: "tblDownloadFiles" }
const _hoisted_51 = { id: "tbodyDownload" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  scope: "col",
  style: {"width":"9%"}
}
const _hoisted_54 = {
  scope: "col",
  style: {"width":"9%"}
}
const _hoisted_55 = {
  scope: "col",
  style: {"width":"10%"}
}
const _hoisted_56 = {
  scope: "col",
  style: {"width":"7%"}
}
const _hoisted_57 = {
  scope: "col",
  style: {"width":"35%"}
}
const _hoisted_58 = {
  scope: "col",
  style: {"width":"15%"}
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-list" }, "Preview", -1 /* HOISTED */))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-list" }, "Preview", -1 /* HOISTED */))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-list" }, "Preview", -1 /* HOISTED */))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  key: 0,
  scope: "col",
  style: {"width":"15%"}
}
const _hoisted_69 = ["disabled", "onClick"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download" }, "Download", -1 /* HOISTED */))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 0,
  style: {"margin":"auto"}
}
const _hoisted_73 = {
  class: "div-Pagination",
  style: {"margin-left":"10%","margin-right":"10%"}
}
const _hoisted_74 = {
  key: 0,
  class: "column1"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"1rem"} }, "First Page", -1 /* HOISTED */))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 1,
  class: "column1"
}
const _hoisted_78 = {
  key: 2,
  class: "column2"
}
const _hoisted_79 = {
  key: 3,
  class: "column2"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-right":"1rem"} }, "Last Page", -1 /* HOISTED */))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = {
  class: "modal fade",
  id: "previewModal",
  tabindex: "-1",
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_83 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_84 = { class: "modal-content" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "previewModalLabel"
  }, "Preview"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_86 = {
  class: "modal-body",
  id: "modal-body",
  style: {"white-space":"pre","text-align":"left","font-family":"'MS Gothic'","height":"400px"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))
const _hoisted_88 = {
  class: "modal fade",
  id: "previewPORDModal",
  tabindex: "-1",
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_89 = {
  id: "divPORDMain",
  class: "modal-dialog modal-dialog-scrollable"
}
const _hoisted_90 = { class: "modal-content" }
const _hoisted_91 = { class: "modal-header" }
const _hoisted_92 = {
  class: "PORD-title",
  id: "previewModalLabel"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_94 = {
  class: "modal-body",
  id: "modal-body",
  style: {"white-space":"pre","text-align":"left","font-family":"'MS Gothic'","padding":"1rem 1rem 0rem"}
}
const _hoisted_95 = { id: "tblPORDHeader1" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "From :", -1 /* HOISTED */))
const _hoisted_97 = { style: {"color":"#0000A0"} }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "To :", -1 /* HOISTED */))
const _hoisted_99 = { style: {"color":"#0000A0"} }
const _hoisted_100 = { id: "tblPORDHeader2" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "Dist. Code :", -1 /* HOISTED */))
const _hoisted_102 = { style: {"color":"#0000A0","width":"10%"} }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "Order Number :", -1 /* HOISTED */))
const _hoisted_104 = { style: {"color":"#0000A0","width":"10%"} }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "Order Date :", -1 /* HOISTED */))
const _hoisted_106 = { style: {"color":"#0000A0","width":"10%"} }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total Line :", -1 /* HOISTED */))
const _hoisted_108 = { style: {"color":"#0000A0"} }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Type of Order :", -1 /* HOISTED */))
const _hoisted_110 = { style: {"color":"#0000A0"} }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Reserve Date :", -1 /* HOISTED */))
const _hoisted_112 = { style: {"color":"#0000A0"} }
const _hoisted_113 = /*#__PURE__*/_createStaticVNode("<table id=\"tblPORDList\" data-v-74c92e56><thead data-v-74c92e56><th style=\"width:8%;border-bottom:0px;\" data-v-74c92e56>Item</th><th style=\"width:26%;border-bottom:0px;\" data-v-74c92e56>Part No</th><th style=\"width:8%;border-bottom:0px;\" data-v-74c92e56>Qty</th><th style=\"width:8%;border-bottom:0px;\" data-v-74c92e56>Bin</th><th style=\"width:8%;border-bottom:0px;\" data-v-74c92e56>Item</th><th style=\"width:26%;border-bottom:0px;\" data-v-74c92e56>Part Number</th><th style=\"width:8%;border-bottom:0px;\" data-v-74c92e56>Qty</th><th style=\"width:8%;border-bottom:0px;\" data-v-74c92e56>Bin</th></thead></table>", 1)
const _hoisted_114 = { style: {"height":"273px","overflow-y":"hidden"} }
const _hoisted_115 = { id: "tblPORDList" }
const _hoisted_116 = { style: {"width":"8%"} }
const _hoisted_117 = { style: {"width":"26%"} }
const _hoisted_118 = { style: {"width":"8%"} }
const _hoisted_119 = { style: {"width":"8%"} }
const _hoisted_120 = { style: {"width":"8%"} }
const _hoisted_121 = { style: {"width":"26%"} }
const _hoisted_122 = { style: {"width":"8%"} }
const _hoisted_123 = { style: {"width":"8%"} }
const _hoisted_124 = { class: "div-Pagination" }
const _hoisted_125 = {
  key: 0,
  class: "column1"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"1rem"} }, "First Page", -1 /* HOISTED */))
const _hoisted_127 = [
  _hoisted_126
]
const _hoisted_128 = {
  key: 1,
  class: "column1"
}
const _hoisted_129 = {
  key: 2,
  class: "column2"
}
const _hoisted_130 = {
  key: 3,
  class: "column2"
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-right":"1rem"} }, "Last Page", -1 /* HOISTED */))
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))
const _hoisted_134 = {
  class: "modal fade",
  id: "previewPINVModal",
  tabindex: "-1",
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_135 = {
  id: "divPINVMain",
  class: "modal-dialog modal-dialog-scrollable"
}
const _hoisted_136 = { class: "modal-content" }
const _hoisted_137 = { class: "modal-header" }
const _hoisted_138 = {
  class: "PINV-title",
  id: "previewModalLabel"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_140 = {
  class: "modal-body",
  id: "modal-body",
  style: {"white-space":"pre","text-align":"left","font-family":"'MS Gothic'","padding":"1rem 1rem 0rem"}
}
const _hoisted_141 = { id: "tblPINVHeader1" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "From :", -1 /* HOISTED */))
const _hoisted_143 = { style: {"color":"#0000A0"} }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "To :", -1 /* HOISTED */))
const _hoisted_145 = { style: {"color":"#0000A0"} }
const _hoisted_146 = { id: "tblPINVHeader2" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "Invoice No. :", -1 /* HOISTED */))
const _hoisted_148 = { style: {"color":"#0000A0","width":"10%"} }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "Re-send Flag :", -1 /* HOISTED */))
const _hoisted_150 = { style: {"color":"#0000A0","column-span":"3"} }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Case Count :", -1 /* HOISTED */))
const _hoisted_152 = { style: {"color":"#0000A0"} }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Item Count :", -1 /* HOISTED */))
const _hoisted_154 = { style: {"color":"#0000A0"} }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ship via :", -1 /* HOISTED */))
const _hoisted_156 = { style: {"color":"#0000A0"} }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Currency :", -1 /* HOISTED */))
const _hoisted_158 = { style: {"color":"#0000A0"} }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Trade Terms :", -1 /* HOISTED */))
const _hoisted_160 = { style: {"color":"#0000A0","column-span":"3"} }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total FOB :", -1 /* HOISTED */))
const _hoisted_162 = { style: {"color":"#0000A0"} }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total FOC :", -1 /* HOISTED */))
const _hoisted_164 = { style: {"color":"#0000A0","column-span":"3"} }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Freight :", -1 /* HOISTED */))
const _hoisted_166 = { style: {"color":"#0000A0"} }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Insurance :", -1 /* HOISTED */))
const _hoisted_168 = { style: {"color":"#0000A0"} }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Process Date :", -1 /* HOISTED */))
const _hoisted_170 = { style: {"color":"#0000A0"} }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Vessel Number :", -1 /* HOISTED */))
const _hoisted_172 = { style: {"color":"#0000A0"} }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "E.T.D. :", -1 /* HOISTED */))
const _hoisted_176 = { style: {"color":"#0000A0"} }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "B/L Number :", -1 /* HOISTED */))
const _hoisted_178 = { style: {"color":"#0000A0"} }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "E.T.A. :", -1 /* HOISTED */))
const _hoisted_182 = { style: {"color":"#0000A0"} }
const _hoisted_183 = /*#__PURE__*/_createStaticVNode("<table id=\"tblPINVListHeader\" data-v-74c92e56><thead data-v-74c92e56><th style=\"width:15%;border-bottom:0px;\" data-v-74c92e56>Case Number</th><th style=\"width:15%;border-bottom:0px;\" data-v-74c92e56>Distributor</th><th style=\"width:14%;border-bottom:0px;\" data-v-74c92e56>P/L Number</th><th style=\"width:14%;border-bottom:0px;\" data-v-74c92e56>Net Weight</th><th style=\"width:14%;border-bottom:0px;\" data-v-74c92e56>Gross Weight</th><th style=\"width:14%;border-bottom:0px;\" data-v-74c92e56>Cubic Measure</th><th style=\"width:14%;border-bottom:0px;\" data-v-74c92e56>Container <br data-v-74c92e56>Number</th></thead></table>", 1)
const _hoisted_184 = {
  id: "divPINVListBody",
  style: {"height":"275px","overflow-y":"auto"}
}
const _hoisted_185 = { id: "tblPINVListBody" }
const _hoisted_186 = { style: {"width":"15%"} }
const _hoisted_187 = ["onClick"]
const _hoisted_188 = { style: {"width":"15%"} }
const _hoisted_189 = { style: {"width":"14%"} }
const _hoisted_190 = { style: {"width":"14%"} }
const _hoisted_191 = { style: {"width":"14%"} }
const _hoisted_192 = { style: {"width":"14%"} }
const _hoisted_193 = { style: {"width":"14%"} }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))
const _hoisted_195 = {
  class: "modal fade",
  id: "previewCaseDetailModal",
  tabindex: "-1",
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_196 = {
  id: "divCaseDetailMain",
  class: "modal-dialog"
}
const _hoisted_197 = { class: "modal-content" }
const _hoisted_198 = { class: "modal-header" }
const _hoisted_199 = {
  class: "CaseDetail-title",
  id: "previewModalLabel"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_201 = {
  class: "modal-body",
  id: "modal-body",
  style: {"white-space":"pre","text-align":"left","font-family":"Arial, Helvetica, sans-serif","padding":"1rem 1rem 0rem"}
}
const _hoisted_202 = { id: "tblCaseDetailHeader1" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "Case Number :", -1 /* HOISTED */))
const _hoisted_204 = { style: {"color":"#0000A0"} }
const _hoisted_205 = /*#__PURE__*/_createStaticVNode("<table id=\"tblCaseDetailListHeader\" style=\"width:100%;\" data-v-74c92e56><thead data-v-74c92e56><th style=\"width:6%;border-bottom:0px;\" data-v-74c92e56>Order <br data-v-74c92e56>Number</th><th style=\"width:5%;border-bottom:0px;\" data-v-74c92e56>Item</th><th style=\"width:12%;border-bottom:0px;\" data-v-74c92e56>Ordered Part</th><th style=\"width:4%;border-bottom:0px;\" data-v-74c92e56>Qty</th><th style=\"width:7%;border-bottom:0px;\" data-v-74c92e56>Sales <br data-v-74c92e56>Number</th><th style=\"width:5%;border-bottom:0px;\" data-v-74c92e56>Item</th><th style=\"width:12%;border-bottom:0px;\" data-v-74c92e56>Shipped Part</th><th style=\"width:6%;border-bottom:0px;\" data-v-74c92e56>FOB</th><th style=\"width:7%;border-bottom:0px;\" data-v-74c92e56>Weight <br data-v-74c92e56>(grams)</th><th style=\"width:9%;border-bottom:0px;\" data-v-74c92e56>Tariff (H.S. <br data-v-74c92e56>Code)</th><th style=\"width:7%;border-bottom:0px;\" data-v-74c92e56>Asbestos <br data-v-74c92e56>Flag</th><th style=\"width:20%;border-bottom:0px;\" data-v-74c92e56>Description</th></thead></table>", 1)
const _hoisted_206 = {
  id: "divCaseDetailListBody",
  style: {"height":"437px","width":"100%","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_207 = {
  id: "tblCaseDetailListBody",
  style: {"table-layout":"fixed"}
}
const _hoisted_208 = { style: {"width":"6%"} }
const _hoisted_209 = { style: {"width":"5%"} }
const _hoisted_210 = { style: {"width":"12%"} }
const _hoisted_211 = { style: {"width":"4%"} }
const _hoisted_212 = { style: {"width":"7%"} }
const _hoisted_213 = { style: {"width":"5%"} }
const _hoisted_214 = { style: {"width":"12%"} }
const _hoisted_215 = { style: {"width":"6%"} }
const _hoisted_216 = { style: {"width":"7%"} }
const _hoisted_217 = { style: {"width":"9%"} }
const _hoisted_218 = { style: {"width":"7%"} }
const _hoisted_219 = { style: {"max-width":"20%","text-align":"left"} }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-toggle": "modal",
    "data-bs-target": "#previewPINVModal"
  }, " Close ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], {
      isLoading: $setup.isLoading || $setup.store.getters.stationListData == null
    }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Navigation"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          ($setup.isDownloadBannerMsg == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Since your distributor uses SCAN-PC Batch Transfer, all files received will be displayed in Downloaded. If you have any questions, please contact your distribution administrator or system representative. "))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              class: "adjusting-position form-select des-select",
              style: {"width":"60%"},
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedDestination) = $event)),
              onChange: $setup.getFilesByToStationCodeAllData
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.destinationList[0], (destination, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: destination.stationCode
                }, _toDisplayString(destination.stationCode) + " : " + _toDisplayString(destination.companyName), 9 /* TEXT, PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, $setup.selectedDestination]
            ])
          ])
        ])
      ]),
      _hoisted_10
    ]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "radio",
          id: "notDownloaded",
          value: "notDownloaded",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isDownloaded) = $event)),
          onChange: $setup.getFilesByToStationCodeAllData
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelRadio, $setup.isDownloaded]
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "radio",
          id: "downloaded",
          value: "downloaded",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isDownloaded) = $event)),
          onChange: $setup.getFilesByToStationCodeAllData
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelRadio, $setup.isDownloaded]
        ]),
        _hoisted_16
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("input", {
          type: "date",
          class: "form-control",
          id: "startDate",
          onKeypress: _cache[3] || (_cache[3] = ($event: any) => ($setup.blockInput($event))),
          onKeydown: _cache[4] || (_cache[4] = ($event: any) => ($setup.blockInput($event))),
          onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.startDateChange($event))),
          value: $setup.startDate
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_19)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control",
          id: "endDate",
          disabled: "",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.endDate) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.endDate]
        ])
      ]),
      _createVNode($setup["Manual"], { class: "align-right-position" })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("select", {
        class: "adjusting-position form-select margin-left",
        onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.dataIdChange($event))),
        value: $setup.selectDataId
      }, [
        _hoisted_24,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.uniqueDataID[0], (id, index) => {
          return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(id), 1 /* TEXT */))
        }), 128 /* KEYED_FRAGMENT */))
      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_23),
      _hoisted_25,
      _createElementVNode("select", {
        class: "adjusting-position form-select margin-left",
        onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.fromStationChange($event))),
        value: $setup.selectFromStation
      }, [
        _hoisted_27,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.uniqueFromStaion[0], (stationCodeId, index) => {
          return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(stationCodeId), 1 /* TEXT */))
        }), 128 /* KEYED_FRAGMENT */))
      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_26),
      _createElementVNode("label", _hoisted_28, _toDisplayString($setup.SCANPageShowLenght) + " / " + _toDisplayString($setup.SCANAllRowLenght) + " Items", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_29, [
        ($setup.isDownloaded === 'notDownloaded' && $setup.isAuthUser == true)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary btn-width",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.pcBatchDownload())),
              disabled: $setup.downloadFiles.length === 0 || !$setup.isEnableDownload
            }, _hoisted_33, 8 /* PROPS */, _hoisted_30))
          : _createCommentVNode("v-if", true),
        ($setup.isAuthUser == true && ($setup.store.getters.stationCode != '1000' && $setup.store.getters.stationCode != $setup.selectedDestination))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  disabled: $setup.store.getters.stationCode != '1000' && $setup.store.getters.stationCode != $setup.selectedDestination,
                  class: "btn btn-primary margin-left btn-width"
                }, _hoisted_37, 8 /* PROPS */, _hoisted_34)
              ]),
              _: 1 /* STABLE */
            }))
          : ($setup.isAuthUser == true)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "/PcUpload"
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("table", _hoisted_40, [
        _createElementVNode("thead", _hoisted_41, [
          _createElementVNode("tr", null, [
            _hoisted_42,
            _hoisted_43,
            _hoisted_44,
            _hoisted_45,
            _hoisted_46,
            _hoisted_47,
            ($setup.isAuthUser == true)
              ? (_openBlock(), _createElementBlock("th", _hoisted_48, "Download"))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("table", _hoisted_50, [
        _createElementVNode("tbody", _hoisted_51, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.downloadFiles, (file, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              ($setup.checkDataId(file))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                    _createElementVNode("td", _hoisted_53, _toDisplayString(file.id), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_54, _toDisplayString(file.dataId), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(file.refNumber), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_56, _toDisplayString(file.fromStationCode_id), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(file.uploadDate), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_58, [
                      (file.dataId == 'PORD')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary",
                            "data-bs-toggle": "modal",
                            style: {"height":"30px !important","padding":"0.2rem 0.375rem 0.2rem 0.375rem"},
                            "data-bs-target": "#previewPORDModal",
                            onClick: ($event: any) => ($setup.PORDModalClick(index, file))
                          }, _hoisted_61, 8 /* PROPS */, _hoisted_59))
                        : (file.dataId == 'PINV')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-primary",
                              "data-bs-toggle": "modal",
                              style: {"height":":30px !important","padding":"0.2rem 0.375rem 0.2rem 0.375rem"},
                              "data-bs-target": "#previewPINVModal",
                              onClick: ($event: any) => ($setup.PINVModalClick(index, file))
                            }, _hoisted_64, 8 /* PROPS */, _hoisted_62))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "btn btn-primary",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#previewModal",
                              style: {"height":"30px !important","padding":"0.2rem 0.375rem 0.2rem 0.375rem"},
                              onClick: ($event: any) => ($setup.modalClick(index))
                            }, _hoisted_67, 8 /* PROPS */, _hoisted_65))
                    ]),
                    ($setup.isAuthUser == true)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                          _createElementVNode("button", {
                            type: "button",
                            disabled: !$setup.isEnableDownload && $setup.isDownloaded === 'notDownloaded',
                            class: "btn btn-primary",
                            style: {"height":":30px !important","padding":"0.2rem 0.375rem 0.2rem 0.375rem"},
                            onClick: ($event: any) => ($setup.pcDownload(file))
                          }, _hoisted_71, 8 /* PROPS */, _hoisted_69)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */)),
          ($setup.downloadFiles.length === 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_72, "No Files"))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      ($setup.SCANPageNumber == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
        : (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _createElementVNode("button", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.changeSCANPage('Back'))),
              type: "button",
              class: "btn-primary",
              style: {"width":"90px","line-height":"1rem","height":"25px","background-color":"#00368f","border-color":"#00368f","margin-left":"1rem"}
            }, _toDisplayString($setup.SCANBackBtnText), 1 /* TEXT */)
          ])),
      ($setup.SCANPageCount > 1 && $setup.SCANPageNumber < $setup.SCANPageCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.changeSCANPage('Next'))),
              type: "button",
              class: "btn-primary",
              style: {"width":"90px","line-height":"1rem","height":"25px","background-color":"#00368f","border-color":"#00368f","margin-right":"1rem"}
            }, _toDisplayString($setup.SCANNextBtnText), 1 /* TEXT */)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_81))
    ]),
    _createElementVNode("div", _hoisted_82, [
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          _hoisted_85,
          _createElementVNode("div", _hoisted_86, _toDisplayString($setup.fileBody[0]), 1 /* TEXT */),
          _hoisted_87
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_88, [
      _createElementVNode("div", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("h5", _hoisted_92, _toDisplayString($setup.PORDTitle), 1 /* TEXT */),
            _hoisted_93
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("table", _hoisted_95, [
              _createElementVNode("tr", null, [
                _hoisted_96,
                _createElementVNode("td", _hoisted_97, _toDisplayString($setup.PORDHeader[0]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_98,
                _createElementVNode("td", _hoisted_99, _toDisplayString($setup.PORDHeader[1]), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("table", _hoisted_100, [
              _createElementVNode("tr", null, [
                _hoisted_101,
                _createElementVNode("td", _hoisted_102, _toDisplayString($setup.PORDHeader[2]), 1 /* TEXT */),
                _hoisted_103,
                _createElementVNode("td", _hoisted_104, _toDisplayString($setup.PORDHeader[3]), 1 /* TEXT */),
                _hoisted_105,
                _createElementVNode("td", _hoisted_106, _toDisplayString($setup.PORDHeader[4]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_107,
                _createElementVNode("td", _hoisted_108, _toDisplayString($setup.PORDHeader[5]), 1 /* TEXT */),
                _hoisted_109,
                _createElementVNode("td", _hoisted_110, _toDisplayString($setup.PORDHeader[6]), 1 /* TEXT */),
                _hoisted_111,
                _createElementVNode("td", _hoisted_112, _toDisplayString($setup.PORDHeader[7]), 1 /* TEXT */)
              ])
            ]),
            _hoisted_113,
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("table", _hoisted_115, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.PORDTenRowtable, (info, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_116, _toDisplayString(info.Item1), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_117, _toDisplayString(info.PartNo1), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_118, _toDisplayString(info.Qty1), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_119, _toDisplayString(info.Bin1), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_120, _toDisplayString(info.Item2), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_121, _toDisplayString(info.PartNo2), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_122, _toDisplayString(info.Qty2), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_123, _toDisplayString(info.Bin2), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_124, [
            ($setup.PORDPageNumber == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, _hoisted_127))
              : (_openBlock(), _createElementBlock("div", _hoisted_128, [
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.changePORDPage('Back'))),
                    type: "button",
                    class: "btn-primary",
                    style: {"width":"90px","line-height":"1rem","height":"25px","background-color":"#00368f","border-color":"#00368f","margin-left":"1rem"}
                  }, _toDisplayString($setup.PORDBackBtnText), 1 /* TEXT */)
                ])),
            ($setup.PORDPageCount > 1 && $setup.PORDPageNumber < $setup.PORDPageCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                  _createElementVNode("button", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.changePORDPage('Next'))),
                    type: "button",
                    class: "btn-primary",
                    style: {"width":"90px","line-height":"1rem","height":"25px","background-color":"#00368f","border-color":"#00368f","margin-right":"1rem"}
                  }, " Next >> ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_130, _hoisted_132))
          ]),
          _hoisted_133
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_134, [
      _createElementVNode("div", _hoisted_135, [
        _createElementVNode("div", _hoisted_136, [
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("h5", _hoisted_138, _toDisplayString($setup.PINVTitle), 1 /* TEXT */),
            _hoisted_139
          ]),
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("table", _hoisted_141, [
              _createElementVNode("tr", null, [
                _hoisted_142,
                _createElementVNode("td", _hoisted_143, _toDisplayString($setup.PINVHeader[0]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_144,
                _createElementVNode("td", _hoisted_145, _toDisplayString($setup.PINVHeader[1]), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("table", _hoisted_146, [
              _createElementVNode("tr", null, [
                _hoisted_147,
                _createElementVNode("td", _hoisted_148, _toDisplayString($setup.PINVHeader[2]), 1 /* TEXT */),
                _hoisted_149,
                _createElementVNode("td", _hoisted_150, _toDisplayString($setup.PINVHeader[3]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_151,
                _createElementVNode("td", _hoisted_152, _toDisplayString($setup.PINVHeader[4]), 1 /* TEXT */),
                _hoisted_153,
                _createElementVNode("td", _hoisted_154, _toDisplayString($setup.PINVHeader[5]), 1 /* TEXT */),
                _hoisted_155,
                _createElementVNode("td", _hoisted_156, _toDisplayString($setup.PINVHeader[6]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_157,
                _createElementVNode("td", _hoisted_158, _toDisplayString($setup.PINVHeader[7]), 1 /* TEXT */),
                _hoisted_159,
                _createElementVNode("td", _hoisted_160, _toDisplayString($setup.PINVHeader[8]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_161,
                _createElementVNode("td", _hoisted_162, _toDisplayString($setup.PINVHeader[9]), 1 /* TEXT */),
                _hoisted_163,
                _createElementVNode("td", _hoisted_164, _toDisplayString($setup.PINVHeader[10]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_165,
                _createElementVNode("td", _hoisted_166, _toDisplayString($setup.PINVHeader[11]), 1 /* TEXT */),
                _hoisted_167,
                _createElementVNode("td", _hoisted_168, _toDisplayString($setup.PINVHeader[12]), 1 /* TEXT */),
                _hoisted_169,
                _createElementVNode("td", _hoisted_170, _toDisplayString($setup.PINVHeader[13]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_171,
                _createElementVNode("td", _hoisted_172, _toDisplayString($setup.PINVHeader[14]), 1 /* TEXT */),
                _hoisted_173,
                _hoisted_174,
                _hoisted_175,
                _createElementVNode("td", _hoisted_176, _toDisplayString($setup.PINVHeader[15]), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_177,
                _createElementVNode("td", _hoisted_178, _toDisplayString($setup.PINVHeader[16]), 1 /* TEXT */),
                _hoisted_179,
                _hoisted_180,
                _hoisted_181,
                _createElementVNode("td", _hoisted_182, _toDisplayString($setup.PINVHeader[17]), 1 /* TEXT */)
              ])
            ]),
            _hoisted_183,
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("table", _hoisted_185, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.PINVDatatable, (info, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_186, [
                        _createElementVNode("a", {
                          type: "button",
                          style: {"text-decoration":"underline","color":"#00368f"},
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#previewCaseDetailModal",
                          onClick: ($event: any) => ($setup.CaseDetailModalClick(info))
                        }, _toDisplayString(info.CaseNumber), 9 /* TEXT, PROPS */, _hoisted_187)
                      ]),
                      _createElementVNode("td", _hoisted_188, _toDisplayString(info.Distributor), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_189, _toDisplayString(info.PLNumber), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_190, _toDisplayString(info.NetWeight), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_191, _toDisplayString(info.GrossWeight), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_192, _toDisplayString(info.CubicMeasure), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_193, _toDisplayString(info.ContainerNumber), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ]),
          _hoisted_194
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_195, [
      _createElementVNode("div", _hoisted_196, [
        _createElementVNode("div", _hoisted_197, [
          _createElementVNode("div", _hoisted_198, [
            _createElementVNode("h5", _hoisted_199, _toDisplayString($setup.CaseDetailTitle), 1 /* TEXT */),
            _hoisted_200
          ]),
          _createElementVNode("div", _hoisted_201, [
            _createElementVNode("table", _hoisted_202, [
              _createElementVNode("tr", null, [
                _hoisted_203,
                _createElementVNode("td", _hoisted_204, _toDisplayString($setup.CaseDetailHeader[0]), 1 /* TEXT */)
              ])
            ]),
            _hoisted_205,
            _createElementVNode("div", _hoisted_206, [
              _createElementVNode("table", _hoisted_207, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CaseDetailDatatable, (info, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_208, _toDisplayString(info.OrderNumber), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_209, _toDisplayString(info.Item1), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_210, _toDisplayString(info.OrderPart), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_211, _toDisplayString(info.Qty), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_212, _toDisplayString(info.SalesNumber), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_213, _toDisplayString(info.Item2), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_214, _toDisplayString(info.ShippedPart), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_215, _toDisplayString(info.FOB), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_216, _toDisplayString(info.WeightG), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_217, _toDisplayString(info.Tariff), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_218, _toDisplayString(info.AsbestosFlag), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_219, _toDisplayString(info.Description), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ]),
          _hoisted_220
        ])
      ])
    ])
  ]))
}